import React from 'react';
import { AlertCircle, XCircle, CheckCircle2 } from 'lucide-react';
export function PainAgitation() {
  return <section className="py-16 md:py-24 bg-white text-[#3D2B1F]" data-id="element-81">
      <div className="max-w-3xl mx-auto px-6" data-id="element-82">
        {/* Not Another Planner */}
        <div className="mb-20" data-id="element-83">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-84">
            Esto no es otro planner
          </h2>

          <div className="bg-[#F5E6D3]/30 rounded-2xl p-8 md:p-10 border border-[#F5E6D3]" data-id="element-85">
            <p className="text-lg mb-6 leading-relaxed" data-id="element-86">
              Si has comprado agendas, descargado plantillas, visto rutinas en
              TikTok, guardado “tips” en Instagram… y aun así terminas el día
              sintiéndote peor:
            </p>

            <p className="font-bold text-xl mb-6 text-[#E8856C]" data-id="element-87">
              No es porque seas floja.
            </p>

            <p className="text-lg mb-6 leading-relaxed" data-id="element-88">
              Es porque esas soluciones están hechas para una versión tuya que
              descansa, tiene ayuda, y no vive interrumpida.
            </p>

            <p className="text-lg mb-6 leading-relaxed" data-id="element-89">
              Pero tú estás criando niños pequeños. Y eso significa que tu día
              no se ejecuta en línea recta. Se rompe. Se reinicia. Se vuelve a
              romper.
            </p>

            <div className="flex items-start gap-4 bg-[#FFF8F0] p-6 rounded-xl border-l-4 border-[#E8856C]" data-id="element-90">
              <CheckCircle2 className="w-6 h-6 text-[#E8856C] flex-shrink-0 mt-1" data-id="element-91" />
              <p className="font-medium text-lg" data-id="element-92">
                Por eso necesitas otra cosa: Un sistema mínimo, repetible, que
                funcione incluso en tu peor día.
              </p>
            </div>
          </div>
        </div>

        {/* Alarm Mode Symptoms */}
        <div data-id="element-93">
          <div className="text-center mb-12" data-id="element-94">
            <span className="text-[#E8856C] font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-95">
              Diagnóstico
            </span>
            <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4" data-id="element-96">
              Señales de que estás en Modo Alarma
            </h2>
            <p className="text-[#3D2B1F]/70 italic" data-id="element-97">
              (y quizá ya lo normalizaste)
            </p>
          </div>

          <div className="grid gap-4" data-id="element-98">
            {['Te molestan sonidos que antes no te afectaban', 'Te duele la mandíbula o los hombros de tanta tensión', 'Estás “bien” hasta que una cosa pequeña te rompe', 'Sientes culpa por no disfrutar más de tus hijos', 'Te da vergüenza admitir que necesitas espacio', 'Te acuestas agotada… y tu mente no se apaga'].map((symptom, idx) => <div key={idx} className="flex items-center gap-4 p-4 rounded-lg hover:bg-[#FFF8F0] transition-colors border border-transparent hover:border-[#F5E6D3]" data-id="element-99">
                <XCircle className="w-6 h-6 text-[#E8856C] flex-shrink-0" data-id="element-100" />
                <span className="text-lg font-medium" data-id="element-101">{symptom}</span>
              </div>)}
          </div>

          <div className="mt-12 text-center bg-[#3D2B1F] text-[#FFF8F0] p-8 rounded-2xl shadow-xl" data-id="element-102">
            <p className="text-xl md:text-2xl font-serif italic" data-id="element-103">
              “Eso no es ser dramática. Eso es un cuerpo sin recuperación.”
            </p>
          </div>
        </div>
      </div>
    </section>;
}